import Highlight from 'containers/NewReviewed/components/Highlight';
import {useEffect, useState} from 'react';
import {fetchReviewGoalService} from 'store/services/compositionServices';
import {ReviewGoal} from 'utils/types/newReviewed';
import LetrusLoader from 'components/LetrusLoader';
import useTrackEvent from 'utils/hooks/useTrackEvent';
import GeneralErrorModal from 'components/GeneralErrorModal';
import {Modal} from 'components/ui';
import {useModals} from 'letrus-ui';
// import styles from './FeedbackModal.module.scss';

interface FeedbackModalProps {
  isOpen: boolean;
  onClose(): void;
  reviewId?: number;
  onContinue(): void;
  competenceId?: number;
  compositionId?: number;
}

function FeedbackModal({
  isOpen,
  onClose,
  reviewId,
  onContinue,
  competenceId,
  compositionId,
}: FeedbackModalProps): JSX.Element {
  const [reviewGoal, setReviewGoal] = useState<ReviewGoal>();

  const {trackEvent} = useTrackEvent();
  const modals = useModals(['error']);

  useEffect(() => {
    if (!reviewId || !competenceId) return;
    fetchReviewGoalService({competenceId, reviewId})
      .then((response) => {
        setReviewGoal(response.data);
      })
      .catch(() => modals.error?.showModal());
  }, []);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      clickOutsideToClose={false}
      maxHeight={459}
      maxWidth={717}
      buttonClose={false}
    >
      {reviewGoal ? (
        <Highlight
          isHighlightModal
          variant="attention"
          onClickMainButton={onContinue}
          indicator={reviewGoal.indicator}
          subtitle={reviewGoal.competence_nickname}
          comment={reviewGoal.comment.podemos_melhorar}
          competenceName={reviewGoal.competence_name}
          onClickSeeMoreButton={() =>
            trackEvent('step5_feedback_content_expanded', {
              composition: {
                composition_id: compositionId,
              },
              competence: {
                competence_id: competenceId ?? 0,
              },
            })
          }
        />
      ) : (
        <div style={{margin: '3rem 1rem'}}>
          <LetrusLoader />

          <GeneralErrorModal
            id="error"
            title="Atenção!"
            showIcon={false}
            description="Houve um problema ao carregar sua redação, tente novamente mais tarde"
          />
        </div>
      )}
    </Modal>
  );
}

export default FeedbackModal;
